import React, { memo } from "react";
import ReactTable from "react-table";

const Table = (props) => <ReactTable {...props} />;

export default memo(Table);